module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "figc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg5_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ack-title"
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To all my students, you have been my best teachers!")]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("To “Strings,” my minigroup, for all the support and love you’ve given me throughout the years; Susanne M. Rasmussen, for your expedience and excellent machine quilting; Joyce Lytle and Lee Jonsson, for helping me make my dream a reality; Jennifer Sampou, for your inspirational designs; and C&T Publishing, for believing in me.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84a862d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_acknowledgement.vue
// module id = 66
// module chunks = 0